import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Button, Breadcrumb } from 'element-react'
import Spacer from '../views/includes/Spacer'
import { MainSection } from '../views/includes/Wrappers'
import CustomLoader from '../user/includes/CustomLoader'
import useAdmin from '../../hooks/useAdmin'
import AppRoutes from '../../routes/appRoutes'
import * as XLSX from 'xlsx'

const ManageReports = props => {
    const [isLoading, setIsLoading] = useState(false)
    const {
        handleUsersReport,
        handleUsersLoginReport,
        handleSalesRepLoginReport,
    } = useAdmin()

    const loadExcelFile = (sheetInfo, workBook) => {
        const tittles = sheetInfo?.tittle
        const data = sheetInfo?.user_info
        const sheetName = sheetInfo?.sheet_name

        const excelHeader = tittles && tittles[0] && Object.keys(tittles[0])
        let workSheet = XLSX.utils.json_to_sheet(tittles, {
            header: excelHeader,
            skipHeader: true,
            origin: 0,
        })

        XLSX.utils.sheet_add_json(workSheet, data, {
            header: excelHeader,
            skipHeader: true,
            origin: -1, //ok
        })

        XLSX.utils.book_append_sheet(workBook, workSheet, sheetName)
    }

    const handleUsersReportSuccess = res => {
        const fileName = res?.data?.file_name
        const sheetsInfo = res?.data?.sheets

        let workBook = XLSX.utils.book_new()
        sheetsInfo.forEach(sheet => {
            loadExcelFile(sheet, workBook)
        })

        XLSX.writeFile(workBook, fileName)

        setIsLoading(false)
    }

    const handleUsersReportFail = res => {
        console.log(res?.data)
        setIsLoading(false)
    }

    const goBack = () => {
        props.history.goBack()
    }

    const getReportUsers = () => {
        setIsLoading(true)
        handleUsersReport(handleUsersReportSuccess, handleUsersReportFail)
    }

    const getReportLoginUsers = () => {
        setIsLoading(true)
        handleUsersLoginReport(handleUsersReportSuccess, handleUsersReportFail)
    }

    const getReportLoginSalesReps = () => {
        setIsLoading(true)
        handleSalesRepLoginReport(
            handleUsersReportSuccess,
            handleUsersReportFail,
        )
    }

    return (
        <MainSection className="admin--add-user">
            <div className="row">
                <div className="columns medium-9">
                    {/* Breadcrumbs */}
                    <Breadcrumb separator="/" className="margin-top-small">
                        <Breadcrumb.Item>
                            <Link to={AppRoutes.home()}>Home</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>Reports</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div className="columns medium-3 show-for-medium">
                    {/* Back Button */}
                    <Button
                        type="text"
                        onClick={goBack}
                        className="button-back margin-top-small"
                    >
                        <i className="icon-chevron-thin-left"></i> Go Back
                    </Button>
                </div>
            </div>
            <div className="row">
                <div className="small-12 columns">
                    <Spacer size="small" />

                    <div className="font-medium text-xl truncate text-black">
                        Download Reports
                    </div>
                    <Spacer size="tiny" />

                    <div className="flex justify-between items-center">
                        <div className="font-medium ">
                            Download Users information
                        </div>
                        <Button type="primary" onClick={getReportUsers}>
                            <span className="icon-download1" />{' '}
                            <span>Download</span>
                        </Button>
                    </div>

                    <Spacer size="tiny" />

                    <div className="flex justify-between items-center">
                        <div className="font-medium ">
                            Download last login users information
                        </div>
                        <Button type="primary" onClick={getReportLoginUsers}>
                            <span className="icon-download1" />{' '}
                            <span>Download</span>
                        </Button>
                    </div>

                    <Spacer size="tiny" />

                    <div className="flex justify-between items-center">
                        <div className="font-medium ">
                            Download last login sales rep information
                        </div>
                        <Button
                            type="primary"
                            onClick={getReportLoginSalesReps}
                        >
                            <span className="icon-download1" />{' '}
                            <span>Download</span>
                        </Button>
                    </div>
                </div>
            </div>
            {isLoading && (
                <div className="demo-loading padding-top-large padding-bottom-large">
                    {' '}
                    <CustomLoader text="Loading" />
                </div>
            )}
        </MainSection>
    )
}

ManageReports.propTypes = {
    history: PropTypes.shape({
        goBack: PropTypes.func,
    }),
}

export default ManageReports
